/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resetAt: NonNullable<unknown> }} Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs */

const en_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You've used all your AI credits for this cycle. Credits reset on ${i?.resetAt}.`)
};

const de_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast alle KI-Credits für diesen Zyklus verbraucht. Credits werden am ${i?.resetAt} zurückgesetzt.`)
};

const fr_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez utilisé tous vos crédits IA pour ce cycle. Les crédits seront réinitialisés le ${i?.resetAt}.`)
};

const es_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Has usado todos tus créditos de IA en este ciclo. Los créditos se restablecen el ${i?.resetAt}.`)
};

const it_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai usato tutti i tuoi crediti IA per questo ciclo. I crediti si ripristinano il ${i?.resetAt}.`)
};

const nl_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je hebt al je AI-credits voor deze cyclus gebruikt. Credits worden op ${i?.resetAt} gereset.`)
};

const pl_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wykorzystałeś wszystkie kredyty AI w tym cyklu. Kredyty zostaną zresetowane ${i?.resetAt}.`)
};

const fi_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olet käyttänyt kaikki AI-krediittisi tältä jaksolta. Krediitit palautuvat ${i?.resetAt}.`)
};

const da_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har brugt alle dine AI-credits for denne cyklus. Credits nulstilles den ${i?.resetAt}.`)
};

const sv_keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har använt alla dina AI-credits för denna cykel. Credits återställs den ${i?.resetAt}.`)
};

/**
* | output |
* | --- |
* | "You've used all your AI credits for this cycle. Credits reset on {resetAt}." |
*
* @param {Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_generate_cta_out_of_credits_hint = /** @type {((inputs: Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Generate_Cta_Out_Of_Credits_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "fr") return fr_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "es") return es_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "it") return it_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "nl") return nl_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "pl") return pl_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "fi") return fi_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "da") return da_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	if (locale === "sv") return sv_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
	return en_keyword_optimizer_generate_cta_out_of_credits_hint(inputs)
});